import React from "react";
import { Box, Flex, Heading, Card, CardHeader, CardBody, Text, VStack, Button } from "@chakra-ui/react";

const Dashboard = () => {
  return (
    <Box p={6}>
      <Heading mb={4}>Welcome to the Admin Dashboard</Heading>
      {/* Sections */}
      <Flex direction="column" gap={6}>
        {/* Placeholder Section 1 */}
        <Card>
          <CardHeader>
            <Heading size="md">Section 1</Heading>
          </CardHeader>
          <CardBody>
            <Text fontSize="lg" color="gray.500">
              Content for Section 1 goes here.
            </Text>
          </CardBody>
        </Card>
        {/* Placeholder Section 2 */}
        <Card>
          <CardHeader>
            <Heading size="md">Section 2</Heading>
          </CardHeader>
          <CardBody>
            <Text fontSize="lg" color="gray.500">
              Content for Section 2 goes here.
            </Text>
          </CardBody>
        </Card>
        {/* Quick Actions */}
        <Card>
          <CardHeader>
            <Heading size="md">Quick Actions</Heading>
          </CardHeader>
          <CardBody>
            <VStack spacing={4} align="stretch">
              <Button
                bg="var(--primary-color)"
                color="white"
                _hover={{
                  bg: "var(--primary-color-hover)",
                  color: "var(--primary-color)",
                  transform: "none",
                }}
                _active={{
                  bg: "var(--primary-color-hover)",
                }}
                _focus={{
                  boxShadow: "none",
                }}
              >
                Action 1
              </Button>
              <Button
                bg="var(--primary-color)"
                color="white"
                _hover={{
                  bg: "var(--primary-color-hover)",
                  color: "var(--primary-color)",
                  transform: "none",
                }}
                _active={{
                  bg: "var(--primary-color-hover)",
                }}
                _focus={{
                  boxShadow: "none",
                }}
              >
                Action 2
              </Button>
            </VStack>
          </CardBody>
        </Card>
      </Flex>
    </Box>
  );
};

export default Dashboard;